<div class="row">
  <div class="col-12">
    <table class="table">
      <caption class="sr-only">Tabella lista ruoli</caption>
      <thead>
        <tr>
          <th class="col-xs-3">Nome</th>
          <th class="col-xs-3">Descrizione</th>
          <th class="col-xs-3"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let role of roles.items">
          <td class="col-xs-3 cell">{{role.name}}</td>
          <td class="col-xs-3 cell">{{role.description}}</td>
          <td class="rightaligned">

            <div class="data_opzioni classificazione">
              <ul>
                <li class="opzioni" appDropdownFocus>
                  <a class="dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
                    aria-expanded="false">Opzioni<span class="glyphicon glyphicon-option-vertical"></span></a>
                  <div class="dropdown-menu">
                    <ul>
                      <li><span class="glyphicon ml-0 glyphicon-pencil span-icon"></span><a href="javascript:void(0)"
                          (click)="onEdit(role)">Modifica</a></li>
                      <li><span class="glyphicon ml-0 glyphicon-trash span-icon"></span><a href="javascript:void(0)"
                          (click)="onDelete(role)">Elimina</a></li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="card-pagination">
  <app-pagination
    [totalItems]="roles.totalItems"
    [hasAutoRefresh]="true"
    [resetCurrentPage]="resetCurrentPage"
    (refreshEvent)="refreshEvent.emit($event)"
  >
  </app-pagination>
</div>
